<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <el-dialog
    title="批量发起退车"
    :visible.sync="visible"
    :before-close="handleModalClose">
    <div class="modal-inner-box">
      <div class="tips-area mt-24">
        <p>导入说明：</p>
        <p class="mt-16">1、点击“下载模板”，并使用模板Excel进行数据填写。</p>
        <p>2、确保填写字段信息与模板中标题保持一致，模板Excel中带有“*”标识的信息为必填项。</p>
        <p>3、点击“导入数据”完成数据上传。</p>
      </div>
      <div class="operating-area mt-48">
        <div class="btns-area">
          <el-upload
            action=""
            accept=".xls,.xlsx"
            :fileList="upload.fileList"
            :limit="1"
            :http-request="uploadRequest"
            :autoUpload="true"
            :show-file-list="false"
          >
            <el-button
              :loading="upload.loading"
              type="primary"
            >
            导入数据
            </el-button>
          </el-upload>

          <el-button class="ml-16" type="text" @click="handleDownloadTemplate">下载导入模板</el-button>
          <el-button v-if="upload.taskId" class="ml-16" type="text" @click="() => getUploadTaskDetail(upload.taskId)">查看导入进度</el-button>
        </div>
        <div v-if="upload.fileList.length" class="progress-area mt-16">
          <p>{{upload.fileList[0].name}}</p>
          <p class="ml-16"><i class="icon QS-icon-loading" v-if="upload.taskDetail.loading" />{{upload.stateLabel}}</p>
          <i class="ml-8 el-icon-delete" @click="removeFile"></i>
        </div>
        <div v-if="uploadErrorStates.includes(upload.taskDetail.state)" class="result-area mt-16">
          <span>
            共导入数据{{upload.taskDetail.totalNum}}条数据，
            导入成功{{upload.taskDetail.successNum}}条，
            导入失败{{upload.taskDetail.failNum}}条。
          </span>
          <a href='javascript:void(0)' @click="handelViewErrorDetail">查看错误详情</a>
        </div>

        <div v-if="uploadErrorStates.includes(upload.taskDetail.state) && table.show">
          <QS-common-table
            :data="upload.taskDetail.data"
            :columns="table.columns"
            :pagination="table.pagination"
            @change="handlePaginationChange"
          >
          </QS-common-table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { uploadTaskCreate } from '@/api/domain/others'
import { uploadTaskGetDetail as getUploadTaskResultDetail } from '@/api/currencyApi'
import { uploadFile, getUploadTaskDetail } from '@/api/domain/returnLease'
import { BATCH_UPLOAD_TEMPLATE_URL } from '@/pages/cars/returnCar/list/config'

const UPLOAD_STATE_LABEL_UPLOADING = '上传中'
const UPLOAD_STATE_LABEL_FAILED = '上传失败'
const UPLOAD_STATE_LABEL_SUCCESS = '上传成功'
const UPLOAD_STATE_LABEL_PROCESSING = '导入中'
const UPLOAD_STATE_LABEL_COMPLETED = '已完成'

const UPLOAD_TYPE_RETURN_CAR = 48 // 48: 客户还车批量上传

const TOTAL = 0
const PAGE_SIZE = 10
const PAGE_SIZES = [10, 20, 30, 50]
const PAGE_NUM = 1

const UPLOAD_SUCCESS_STATES = [3] // 3: 全部成功
const UPLOAD_ERROR_STATES = [4, 5] // 4: 全部错误 5: 部分错误

export default {
  props: ['visible'],
  data() {
    return {
      upload: {
        fileList: [],
        stateLabel: '',
        loading: false,
        taskId: 0,
        taskDetail: {
          state: 0,
          data: [],
          totalNum: 0,
          successNum: 0,
          failNum: 0,
          loading: false,
        },
      },
      uploadSuccessStates: UPLOAD_SUCCESS_STATES,
      uploadErrorStates: UPLOAD_ERROR_STATES,
      table: {
        columns: [
          {
            name: 'lineNo',
            columnProps: {
              prop: 'lineNo',
              label: '错误行',
            },
          },
          {
            name: 'resultInfo',
            columnProps: {
              prop: 'resultInfo',
              label: '错误详情',
            },
          },
        ],
        pagination: {
          pageSize: PAGE_SIZE,
          pageNum: PAGE_NUM,
          total: TOTAL,
          pageSizes: PAGE_SIZES,
        },
        show: false,
      },
    }
  },
  methods: {
    handleModalClose() {
      this.$emit('handelReturnCarModalVisibleChange', false)
      this.resetModal()
    },
    resetModal() {
      this.upload.fileList = []
      this.upload.stateLabel = ''
      this.upload.loading = false
      this.upload.taskId = 0
      this.upload.taskDetail = {
        state: 0,
        data: [],
        totalNum: 0,
        successNum: 0,
        failNum: 0,
      }
      this.table.show = false
    },
    handleDownloadTemplate() {
      window.location.href = BATCH_UPLOAD_TEMPLATE_URL
    },
    handelViewErrorDetail() {
      this.table.show = true
    },
    removeFile() {
      this.resetModal()
    },
    async uploadRequest({ file }) {
      this.upload.fileList = [file]
      this.upload.stateLabel = UPLOAD_STATE_LABEL_UPLOADING
      this.upload.loading = true

      // 上传文件
      let res
      try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('group', 'vehicle')
        formData.append('code', 'vehicle_renting_termination_file')

        res = await uploadFile(formData)
      } catch (err) {
        this.upload.stateLabel = UPLOAD_STATE_LABEL_FAILED
        this.upload.loading = false
        this.upload.fileList = []
      }

      if (!res) return

      // 创建异步解析任务
      const { code, data } = res
      if (code === 1) {
        this.createUploadTask(data, file)
      } else {
        this.upload.stateLabel = UPLOAD_STATE_LABEL_FAILED
        this.upload.loading = false
      }
    },
    // 创建异步导入任务
    async createUploadTask(url, file) {
      let res

      try {
        res = await uploadTaskCreate({
          uploadType: UPLOAD_TYPE_RETURN_CAR,
          fileAddress: url,
          fileName: file.name,
        })
      } catch (err) {
        this.upload.stateLabel = UPLOAD_STATE_LABEL_FAILED
        this.upload.loading = false
      }

      if (!res) return

      const { code, data } = res
      if (code === 1) {
        this.upload.taskId = data
        this.upload.stateLabel = UPLOAD_STATE_LABEL_PROCESSING
        this.$message.success(UPLOAD_STATE_LABEL_SUCCESS)
      } else {
        this.upload.stateLabel = UPLOAD_STATE_LABEL_FAILED
      }
      this.upload.loading = false
    },
    // 获取异步导入任务详情
    async getUploadTaskDetail(taskId) {
      let res

      this.upload.taskDetail.loading = true

      try {
        res = await getUploadTaskDetail({
          id: taskId,
          uploadType: UPLOAD_TYPE_RETURN_CAR,
          pageNum: this.table.pagination.pageNum,
          pageSize: this.table.pagination.pageSize,
        })
      } catch (err) {
        console.log(err)
      }

      this.upload.taskDetail.loading = false

      if (!res) return

      const { code, data } = res
      if (code === 1) {
        let { extInfo } = data
        const { state } = data
        extInfo = JSON.parse(extInfo || '{}')

        this.upload.taskDetail.state = state
        this.upload.taskDetail.totalNum = extInfo?.totalNum || 0
        this.upload.taskDetail.successNum = extInfo?.successNum || 0
        this.upload.taskDetail.failNum = extInfo?.failNum || 0
        this.upload.stateLabel = [...this.uploadSuccessStates, ...this.uploadErrorStates].includes(state) ? UPLOAD_STATE_LABEL_COMPLETED : UPLOAD_STATE_LABEL_PROCESSING

        if (this.uploadErrorStates.includes(state)) {
          this.getUploadTaskResultDetail(taskId)
        }
      }
    },
    // 获取异步导入任务结果详情
    async getUploadTaskResultDetail(taskId) {
      let res

      try {
        res = await getUploadTaskResultDetail({
          id: taskId,
          pageNum: this.table.pagination.pageNum,
          pageSize: this.table.pagination.pageSize,
        })
      } catch (err) { console.log(err) }

      if (!res) return

      const { code, data } = res
      if (code === 1) {
        const { items, totalNum } = data

        this.upload.taskDetail.data = items
        this.table.pagination.total = totalNum
      }
    },
    handlePaginationChange(payload) {
      const { pagination } = payload
      this.table.pagination.pageSize = pagination.pageSize || PAGE_SIZE
      this.table.pagination.pageNum = pagination.pageNum || PAGE_NUM
      this.getUploadTaskResultDetail(this.upload.taskId)
    },
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-icon-delete:hover {
    color: #409EFF;
  }
  .modal-inner-box {
    padding: 16px;
    .el-icon-delete {
      cursor: pointer;
    }
    .mr-8 {
      margin-right: 8px;
    }
    .ml-8 {
      margin-left: 8px;
    }
    .ml-16 {
      margin-left: 16px;
    }
    .ml-16 {
      margin-left: 16px;
    }
    .mt-16 {
      margin-top: 16px;
    }
    .mt-48 {
      margin-top: 48px;
    }
    .btns-area {
      display: flex;
    }
    .progress-area {
      display: flex;
      align-items: center;
    }
  }
</style>
